import { render } from "./list-view.vue?vue&type=template&id=c60346c8"
import script from "./list-view.vue?vue&type=script&lang=js"
export * from "./list-view.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__